var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1788 1788",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(870,404)",
    d: "m0 0 26 2 20 4 10 3 4-1 2-1 11 1 47 11 20 6 17 7 7 3-2-5v-5l9 2 16 7 12 7 10 8 7 7 9 12 2 1 1-7 2-6 5 2 10 8 9 12 8 16 4 13 5 4 11 8 11 12 11 16 6 10 9 21 4 15 2 13 1 14 7 22 2 11 1 13v35l-5 35-6 27-7 24-1 2h11l12 5 7 5 7 10 5 10 4 17 1 6v20l-4 29-7 28-9 21-9 16-13 18-16 20-8 6-13 5-9 1-5 26-7 26-6 16-10 21-12 20-11 14-12 14-16 16-8 7-14 12-5 4 12 8 18 18 6 3 17 3 28 3 34 2 14 3 5 3 6 9 4 4 11 6 11 8 12 12 6 9-2 4-9 8-14 10-19 14-19 12-23 13-19 10-23 11-11 5-18 6-29 10-30 8-28 6-31 4-31 2-24 1-45-2-40-5-29-6-28-7-27-9-27-10-16-8-28-13-15-9-19-11-15-10-20-15-14-10-8-7-2-5 11-13 7-7 10-7 12-7 5-2 4-8 8-6 2-1 70-6 21-3 8-7 12-12 13-8 3-2-15-13-14-12-12-12-7-8-12-14-10-15-10-18-9-19-7-22-5-22-4-23h-8l-16-7-7-6-13-17-11-15-11-18-9-20-6-22-4-22-2-31 2-6 2-14 4-13 5-10 5-6 11-7 13-3v-7l-5-24-5-36-1-30-2-27v-13l2-21 4-17 6-18 8-17 7-10 5-12 6-15 8-14 9-11 9-10 8-7 12-9 8-5 9-11 8-9 10-7 21-10 11-5 15-10 17-9 17-6 21-5 30-5 22-4z",
    fill: "#0A0403"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(733,586)",
    d: "m0 0h41l69 6 18 1h61l39-3 30-2h36l30 3 20 4 12 4 13 7 10 9 7 14 4 14 3 24v22l2 25 5 25 10 31 3 17 2 21v29l-1 21-1 5-1 44-3 24h-2l1 4-2 10-1 9-4 1 1 4-2 1-1 5-2 1-1 7-5 4-2-1-1 4-3 7-9 17-3 6-5 8-8 11-12 15h-2l-2 4-10 13-8 6-4 4h-2l-2-8-4-20-6-11-7-9-13-9-11-5h-12l-16 1-12 2-13 2-40 6h-5l1-3h6l5-3 18-4 5-3 5-10 1-10-3-10-4-8-2-1 4 11v14l-4 8-4 2-6-2h-13l-8 4-11 10-6 4-7-1-11-9-8-6-5-2h-11l-10 1-4-8v-16l3-8h-2l-4 8-2 9v7l3 7 4 7 5 2 13 3 5 3 1 3-2 1h-17l-8 1-7 8-9 17-1 4h5l1 1 12 1 9 2 10 1 22 1 1-12 3-14 3-1-1 14-2 13h34l23-2 9-2-1-5-11-23-2-4 5 2 14 28h15l11-2h5v-2l11-1 3-2h13l4 3-1 3-2-1 5 7v3l-4 2 2 1-3 17-1 3-1 5-4 18-3 14-7 20-9 15-6 7-16 8-12 5-12 3-2 1h-18l-10-10 1-3 14-7-75-1 3 3 10 3 1 5-1 4-12 5h-18l-8-2-4 6-1 3-1 20 1 2-2 6-2 1-6-3 2-1-3-5-2 1-2-4v-10l2-3 2 1 3 10 3 2v-9l-2-10-5-9-2 5 1 2 1 6h-2v-2h-2l-1-15h-2l-2 5v29l-6-2v-16l1-13v-13l-5-3-3 40-5-2-1-6 1-19-3 9-3 11h-2l-1-4 1-5-2-1 7-15 5-13-3-9-5-13-2-2-5 12-4 4 2-9 5-13v-9l-3 3-6 18-2 13 3 1-4 19v11l-4-2-8-7-9-8-3-2v-5l3-1 1-6 2 1v2l4-1 1-5h3l-1-7-1-2-2 1-1-6v-26l-2 7-2 9v13l1 13h-2l-2-9-3-9-1-8 5-18 3-10 1-4 1-14v-7l-4 10-5 34-5 7-1-4 3-22 1-19 2-8 4 1 3-10 8-20 6-10 4-5-6 2-5 2-2 4-4 4-6 12-4 18-3 17-3 16-3 1 1-17v-16l-3 1-1 3-1 30-2 3-1-7v-35l-2-2-4 13-2-3v-8l-4 1-1 10-1 3-4-2 1-10v-14h-2l-1 8v15l-2 4-2-6-3 7-3 16 1 4v7l-3-3-3-9 7-25 3-17v-9l-1-3-5 17-3 14h-2l-1-3-2 3-1-4-1-18v-22l-4-9-1 5h-2l-2-8-2-1 2 13 5 13v15h-3l-2-16-1-2-1 13-2-3-8-36-5-24-8-46-3-34-1-65-4-40v-19l3-17 12-39 3-15 2-17 1-27 2-22 4-15 7-14 8-8 12-7 18-6 16-3z",
    fill: "#A3734F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(884,421)",
    d: "m0 0h8l15 3 27 9 15 8 10 8 8 4h4l-6-9-10-9v-2l7 1 9 5 6 4h4l-5-6 7 1 23 7 19 9 14 10 9 8-1 2-2-1 3 5v3l4 2 3 1-1-3 2-5 1-8 1-3-2-8 5 2 15 15 7 14 1 6h2l5 11 7 17 2-2 5-12 4-2h3l4 7 4 8 1 4-4 13-8 19-4 4-4-16-7-14v-2h-3l-2 5-13 20-10 16h-1l-2-19-7-20-2-2-8 19-2 5-4-2-1-18-3 3-8 16-2 1v-2l-3 1-2-2-3-14-5-10-7-8h-4l-2 12-4 9-7 16-4 5h-13l-2-1-2-22-8-16-2-3h-4l-8 22-6 14h-2l-6-15-10-19-12-13-8-7-2-1v19l-2 18-2 40-4-2-8-6-7-16-8-30-6-12-4-6-2 2-3 15-8 26-4 8-4-2-10-13-8-7-3-1 2 5 2 3v5l-7-3-12-8-26-6 19 19 6 11 6 7 2 6-3 1-18-6-11-4-27-9-23-3 3 5 2 4v3l-2 1-22 1-19 3v2l-19 10-9 7-6 9-5 20-5 14-3 8-8 26-4 8 7-2 2 1 2 7v8l-4 10-4 9-11 21-14 19-2 1-3-11-1-13v-12l3-20 5-23v-4l-3 1-4 6h-2l-2-7v-22l4-16 3-7 1-4 5-14 7-12 11-11 7-6 8-7 13-9 11-5 15-5 2-2h-24l-9 1 1-5 5-4 1-3-4-1-2-7 5-3 4-2 7-1 38-2-9-2-30-1 5-4 14-7 20-3h3l-1-4-14-6 2-4h2l2-4 5-4 17-9 17-6 16-4 31-3-5-4-2-3v-3l-14 2h-5l4-3 22-9 17-4 36-4h21l12 3 9 4h6l1-5-6-2-3-3h3z",
    fill: "#1C1B1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(644,916)",
    d: "m0 0h1l2 7 3 20 1 3-1 3 3 1 3 11 3 9-1 4 3-1 6 11 4 5 3 9 4 4 8 14 3 5 9 11 5 2 3 3v2l5 2 5 6 4 2 2 4 6 3 4-1 2-12 5-12 6-9 8-8 12-6 13-2h12l11 2 17 2 8 2 17 3 19 3 2 2h-17l-8 1-7 8-9 17-1 4h5l1 1 12 1 9 2 10 1 22 1 1-12 3-14 3-1-1 14-2 13h34l23-2 9-2-1-5-11-23-2-4 5 2 14 28h15l11-2h5v-2l11-1 3-2h13l4 3-1 3-2-1 5 7v3l-4 2 2 1-3 17-1 3-1 5-4 18-3 14-7 20-9 15-6 7-16 8-12 5-12 3-2 1h-18l-10-10 1-3 14-7-75-1 3 3 10 3 1 5-1 4-12 5h-18l-8-2-4 6-1 3-1 20 1 2-2 6-2 1-6-3 2-1-3-5-2 1-2-4v-10l2-3 2 1 3 10 3 2v-9l-2-10-5-9-2 5 1 2 1 6h-2v-2h-2l-1-15h-2l-2 5v29l-6-2v-16l1-13v-13l-5-3-3 40-5-2-1-6 1-19-3 9-3 11h-2l-1-4 1-5-2-1 7-15 5-13-3-9-5-13-2-2-5 12-4 4 2-9 5-13v-9l-3 3-6 18-2 13 3 1-4 19v11l-4-2-8-7-9-8-3-2v-5l3-1 1-6 2 1v2l4-1 1-5h3l-1-7-1-2-2 1-1-6v-26l-2 7-2 9v13l1 13h-2l-2-9-3-9-1-8 5-18 3-10 1-4 1-14v-7l-4 10-5 34-5 7-1-4 3-22 1-19 2-8 4 1 3-10 8-20 6-10 4-5-6 2-5 2-2 4-4 4-6 12-4 18-3 17-3 16-3 1 1-17v-16l-3 1-1 3-1 30-2 3-1-7v-35l-2-2-4 13-2-3v-8l-4 1-1 10-1 3-4-2 1-10v-14h-2l-1 8v15l-2 4-2-6-3 7-3 16 1 4v7l-3-3-3-9 7-25 3-17v-9l-1-3-5 17-3 14h-2l-1-3-2 3-1-4-1-18v-22l-4-9-1 5h-2l-2-8-2-1 2 13 5 13v15h-3l-2-16-1-2-1 13-2-3-8-36-5-24-8-46z",
    fill: "#0D0705"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1145,863)",
    d: "m0 0h1l1 21v26l-3 26-6 35-5 19-4 10 1 1-1 13-2 9-2 1 1-12h2l-4-11h-4v10l5 2-2 5-4-2-6-11-1 3 4 9v2h2l2 9h2l2-1-1 9h-2v-5l-5-1-10-8 1 4 1 2v6h-3l-3-3h-2l2 6 4 7 5-1v-10h4l1 2v10l-5 12-6-2 3 11-3-1-7-10-2-1 1-3v-2l-6-7-4-1 1 6 4 5v2l3 1 1 5 3 8-1 3h-3v2h-2l-1-9-7-12-4-4-2 5 8 16v5l-4-5-7-11v-2l-5 3-3 5 1 10h-2l-5-6-1 4 9 20 2 10 3 3 1 10v9l-3 9-2 1 1-9-1-14-4-17-10-17v-3h-3l2 5 1 7 3 7 6 22 3 13v10l-4 2-2-18-4-15-3-10-2-9-3-5-4 1-1-1-2-10-5-10-2-7-1 4-2 1 2 10 3 6 7 9 4 2 4 9v6l-2-2 1 4 2 4 1 12h2l2 13v11l-7 8-4 3-1-1v-16l3 1 1 6h2v2h2l-1-6v-13l-4-19-4-14-1 7-4 1-1-7v-8l-8-15-1-2v11l4 10 3 9 2 5 5 2v5l-3-1 1 10-1 6h-2l-1-2-1-12-5-12v-3h-2v4h-2l-6-12-4-6v-2l-4-1 10 23 6 9 3 3 4 39 1-2h3v2l3 1-5 6-11 9-3 3h-2l2-7v-19l4-1v-11l-1-9-3-12-5-8v-2h-2l-1 11 1 6h2l1 5v8l-4-4-6-15 2-18-3-3-2 10-1 11 2 4v14l2 25 1 2 2-3 1 4h2l1 2v13l2 1-6 3-7 6-16 9-8 4-1-40-4 2-1 5 3 17v8l-2 4h-2l-1-5-1-23-4 8v23l6-1-1 4h2v2l-11 6h-2v-9l-3-2v-2h-2l-1 8-2 4-3 1-2 3-1-1-2-13-2 4-2 10-1 4h-3v-9l-5-24-1-8h-6l2 16v26l-2 2-5-1-4-27-3-9-5-2 2 10 2 31-6-2-2-1-1 4h-7l2-11 2-14-1-20-2-9-2-5-4-1 2 20v28l-1 10h-5l-2-13-3-13h-2l-1 23-1 5h-6l-2-5-1-9h-3l-1 5h-2l-2 2v-2h-2v-18l1-10v-13l-1 1v2h-2l-4 21v19l-1 3h-7l-10-4-5-5h-7l1-9-4-1 3-5 1-9 1-2 4 1 4-1 1-2v-8l16-1 12-5v-7l-12-4-2-3 1-1 76 1-2 3-10 4-3 2 2 4 5 6 2 1h18l8-3 9-2 21-10 6-4 10-15 6-15 5-16 4-22 2-5v-5l2-6 3-12h-10v-1l12-2-4-8-3-4 4 2-1-3-2-1h-13l-3 2h-11v2l-16 3h-15l-10-19-5-10-4-2 5 8 10 21-1 4-17 3-15 1h-32l-2-1 1-13 2-14-2 1-4 20-1 6h-22l-16-2-3-1-12-1-6-2 1-6 8-15 8-9 13-1h14l-3-4-10-3-9-2-5-5-4-7-1-4v-7l3-11 4-7 3 1-3 8v16l3 6v2l10-2h11l10 5 12 11 7 2 5-2 10-9 9-6 3-1h13l8 2 4-6 1-3v-14l-3-8v-3l3 1 6 13 1 10-3 9-5 8-9 3-16 4-2 2h-6l-1 2 45-7 13-2 12-2 16-1h12l14 7 11 8 8 10 6 13 4 25 4-2 5-5 6-5 6-8 5-7 5-5 10-12 4-6 6-10 3-4 8-17 4-6 3-8 4-2 3-1v-7l3-3 2-8 3-1 2-15 1-8h2v-8l2-18z",
    fill: "#805237"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(779,1234)",
    d: "m0 0 2 2 1 14 4 13 9 14 4 5 11 9 10 6 16 8 15 5 24 4h33l22-3 20-6 19-10 14-10 8-8 7-11 5-15 2-17 23 4-1 9-7 24-10 32-13 35-8 19-10 26-4 9-2 3-34 4-45 2-45-2-33-4-6-2-11-29-11-27-9-25-13-41-9-30v-4z",
    fill: "#FEFEFD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1010,793)",
    d: "m0 0h28l17 3 11 4 11 6 12 11 8 9 8 14 2 6-1 7-12 16-7 7-11 8-12 6-19 6-15 3h-22l-14-3-12-4-12-6-11-8-14-12-6-5 1-7 10-24 7-11 9-10 5-4 8-5 16-5z",
    fill: "#110907"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(752,791)",
    d: "m0 0h26l19 3 13 5 11 7 11 11 8 14 8 19 2 6-1 5-10 8-8 7-16 11-15 6-17 4h-26l-21-5-16-6-11-7-13-12-10-12-4-7 1-6 5-12 9-12 12-12 13-8 16-5z",
    fill: "#110A07"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(766,1053)",
    d: "m0 0 6 3 7 1 7 10 8 12 10 13 8 9 11 9 15 10 15 7 19 5 7 1h35l17-4 16-7 16-10 16-15 8-8 11-15 8-13h12l-3 17-1 3-1 5-4 18-3 14-7 20-9 15-6 7-16 8-12 5-12 3-2 1h-18l-10-10 1-3 14-7-75-1 3 3 10 3 1 5-1 4-12 5h-18l-8-2-4 6-1 3-1 20 1 2-2 6-2 1-6-3 2-1-3-5-2 1-2-4v-10l2-3 2 1 3 10 3 2v-9l-2-10-5-9-2 5 1 2 1 6h-2v-2h-2l-1-15h-2l-2 5v29l-6-2v-16l1-13v-13l-5-3-3 40-5-2-1-6 1-19-3 9-3 11h-2l-1-4 1-5-2-1 7-15 5-13-3-9-3-8-4-17-2-11-1-6v-10l-5-24-3-8z",
    fill: "#A3734F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1019,1200)",
    d: "m0 0 8 1 10 4 10 9 8 7 13 12 8 7 7 7 7 8 11 16 10 18 6 15 1 6-4 4-16-1-30-5-14-3h-8v7l4 7 9 11 12 13 13 14 3 3h3v2l-23 8-29 10-30 8-23 5-3-1 3-3 13-30 10-25 15-42 9-30 5-21 2-14v-14l-3-1-4 10-14-1-18-3-3-1 2-4 13-10z",
    fill: "#B8252C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(764,1197)",
    d: "m0 0 5 2 10 7 8 6 5 2v2l-10 2-26 4h-4l-2-13h-2l-1 17 2 18 6 23 8 26 5 12 16 47 13 35v4l-13-2-32-8-27-9-27-10-6-3 2-1h8l2-4 9-9 9-11 13-14 6-10 1-6h-9l-20 3-25 4-10 1h-10l-1-4 3-10 9-17 6-11 12-17 8-10 7-7 10-8 13-13 11-9 5-4 10-3z",
    fill: "#B8252C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(825,1229)",
    d: "m0 0 4 1 18 5 21 4h47l11-1 28-6 5-2 5 3 26 3v17l-4 10-8 10-8 8-11 7-11 5-20 6-18 3h-37l-25-5-18-7-13-8-11-10-8-13-2-5-2-18 29-4z",
    fill: "#A2724F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(644,916)",
    d: "m0 0h1l2 7 3 20 1 3-1 3 3 1 3 11 3 9-1 4 3-1 6 11 4 5 3 9 4 4 8 14 3 5 9 11 5 2 3 3v2l5 2 5 6 4 2 2 4 6 3 4-1 2-12 5-12 6-9 8-8 12-6 13-2h12l11 2 17 2 8 2 17 3 19 3 2 2h-17l-8 1-7 8-9 17-1 4h5l1 1 12 1 9 2 10 1 22 1 1-12 3-14 3-1-1 14-2 13h34l23-2 9-2-1-5-11-23-2-4 5 2 14 28h15l11-2h5v-2l11-1 3-2h13l4 3-1 3-2-2h-11l-18 6-35 6-28 3h-55l-36-4-26-5-14-4-8-4h-8l-7 4-1 5-1 3 5 16 3 16v14l2 6 3 15 1 7-4-5-5 12-4 4 2-9 5-13v-9l-3 3-6 18-2 13 3 1-4 19v11l-4-2-8-7-9-8-3-2v-5l3-1 1-6 2 1v2l4-1 1-5h3l-1-7-1-2-2 1-1-6v-26l-2 7-2 9v13l1 13h-2l-2-9-3-9-1-8 5-18 3-10 1-4 1-14v-7l-4 10-5 34-5 7-1-4 3-22 1-19 2-8 4 1 3-10 8-20 6-10 4-5-6 2-5 2-2 4-4 4-6 12-4 18-3 17-3 16-3 1 1-17v-16l-3 1-1 3-1 30-2 3-1-7v-35l-2-2-4 13-2-3v-8l-4 1-1 10-1 3-4-2 1-10v-14h-2l-1 8v15l-2 4-2-6-3 7-3 16 1 4v7l-3-3-3-9 7-25 3-17v-9l-1-3-5 17-3 14h-2l-1-3-2 3-1-4-1-18v-22l-4-9-1 5h-2l-2-8-2-1 2 13 5 13v15h-3l-2-16-1-2-1 13-2-3-8-36-5-24-8-46z",
    fill: "#805237"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1132,530)",
    d: "m0 0 6 2 8 9 7 9 2 4h2v3h2l4 7 1 7 4 2v2l2 1 1 5 3 5 3 11v11l-3 1-7-3 6 12 8 15 7 16 2 9v48l-4 29-4 16-1 2-7-1-11-13-6-8-5-8-6-14-3-12-1-16 2-2 2 4 5-1-1-10-2-14-3-11-7-17-2-10v-9l6-1 5 1-6-9-9-4-6-4 5-5 3-4 1-4-13 1-4-10 1-4-1-6 3 1-1-5 4-10 3-4v-8z",
    fill: "#1C1B1B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1104,1250)",
    d: "m0 0 18 1 24 2 10 3 10 7 3 1v-2h2v-2l4-3 4 1 9 4 8 7 7 8 5 6 1 5 4 1-14 10-19 14-19 12-23 13-19 10-23 11-4 1-7-9-8-8-9-11-9-10-4-5v-3l5-1 17 3 21 2h18l5-3 3-7v-8l-4-14-9-19-7-12-1-4z",
    fill: "#B8252C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(650,1250)",
    d: "m0 0h33l-2 5-13 24-6 17-1 5v7l3 7 5 2h18l15-1 17-3h10l-2 4-12 16-10 11-8 10-5 4-6-2-32-15-15-9-19-11-15-10-20-15-11-8 2-6 12-14 11-9 6-3h6l6 7 5-1 9-6 11-4z",
    fill: "#B8252C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(796,1063)",
    d: "m0 0 9 1 36 6 36 3h31l31-2 38-5 10-2h5l-4 6-2 5-6 7h-4l-1 3-13 4-22 4-33 3-32 1 8 1 13 1 13-1 38-2h7l5 2v3l-7 6-10 6-16 6-12 3-16 1-19-1-16-3-20-8-16-10-1-3-4-2-2-4 15 1 5 1 18 1v-2l-4 1-16-2-22-5-6-4-6-6-3-5-5-7z",
    fill: "#B8242B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1183,810)",
    d: "m0 0h13l8 4 5 6 4 8 3 14v29l-3 21-6 26-7 18-6 11-13 18-12 16-5 6-8 5h-6l-1-4 5-23 4-3 10-5 6-9-5 5-11 6h-2l2-11 5-36 2-39 6-12 4-2 4 4 4 11 2 16-1 18 4-11v-18l-3-14-7-14 1-5 15-13 6-5v-3l-9 3-10 10-8 6 1-10 5-19z",
    fill: "#A1724E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(598,805)",
    d: "m0 0h5l7 21 1 7-4-2-9-7-5-2-4 1 13 12 7 7 1 6-7 18-3 12v16l3 9h1v-21l4-17 5-12h2l5 13 4 16 2 28 4 33 2 12-2 1-8-4-1 1 12 7 3 9 3 16v4l-10-2-8-6-10-13-11-16-8-12-7-16-6-21-5-23-1-8v-32l4-16 5-10 7-6z",
    fill: "#805237"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(944,968)",
    d: "m0 0 3 1 6 13 1 10-3 9-5 8-9 3-16 4-2 2h-6l-1 2 21-2h13l4 6 1-2 4 2 7 9 7 17-4 1h-9l-10-19-5-10-4-2 5 8 10 21-1 4-17 3-15 1h-32l-2-1 1-13 2-14-2 1-4 20-1 6h-22l-16-2-3-1-12-1-6-2 1-6 8-15 8-9 13-1h14l-3-4-10-3-9-2-5-5-4-7-1-4v-7l3-11 4-7 3 1-3 8v16l3 6v2l10-2h11l10 5 12 11 7 2 5-2 10-9 9-6 3-1h13l8 2 4-6 1-3v-14l-3-8z",
    fill: "#815338"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(854,1155)",
    d: "m0 0 76 1-2 3-10 4-3 2 2 4 5 6 2 1h18l8-3 9-2 21-10v3l-1 5 3 17v8l-2 4h-2l-1-5-1-23-4 8v23l6-1-1 4h2v2l-11 6h-2v-9l-3-2v-2h-2l-1 8-2 4-3 1-2 3-1-1-2-13-2 4-2 10-1 4h-3v-9l-5-24-1-8h-6l2 16v26l-2 2-5-1-4-27-3-9-5-2 2 10 2 31-6-2-2-1-1 4h-7l2-11 2-14-1-20-2-9-2-5-4-1 2 20v28l-1 10h-5l-2-13-3-13h-2l-1 23-1 5h-6l-2-5-1-9h-3l-1 5h-2l-2 2v-2h-2v-18l1-10v-13l-1 1v2h-2l-4 21v19l-1 3h-7l-10-4-5-5h-7l1-9-4-1 3-5 1-9 1-2 4 1 4-1 1-2v-8l16-1 12-5v-7l-12-4-2-3z",
    fill: "#805237"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1033,808)",
    d: "m0 0 14 1 12 3 12 6 12 11 8 14 1 2v7l-8 11-10 11-13 9-13 5-13 3-10 1h-13l-17-3-16-6-14-9-10-9-4-5 1-8 5-12 8-12 9-8 12-6 13-4 10-1-3 2-10 6-6 9-3 9v14l3 9 7 9 9 6 9 3h12l11-4 6-4 7-8 4-10 1-10-3-12-7-11-13-8z",
    fill: "#FEFEFD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(758,805)",
    d: "m0 0h6l-1 2-10 3-8 7-5 7-3 9v15l4 10 9 10 10 5 8 2 12-1 14-7 6-7 4-8 1-4v-17l-4-9-7-8-8-5 3-1 13 4 13 7 11 10 7 11 6 16-2 5-10 10-14 9-14 6-12 3-14 1-21-1-17-5-12-6-12-11-9-10-5-8v-6l7-13 11-12 16-8 18-4z",
    fill: "#FEFEFD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1011,809)",
    d: "m0 0h24l11 7 7 10 3 8 1 10-3 12-6 9-8 7-9 4-4 1h-12l-9-3-9-6-6-7-4-8-1-4v-14l4-11 6-8 10-6z",
    fill: "#0C0604"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 712)",
    d: "m0 0h34l18 5 21 10 10 7 9 7 10 10 8 11 1 5-6-3-16-10-15-8-17-6-22-3h-16l-17 2-28 6-27 8h-8l-1-1v-12l4-8 11-7 15-6 19-5z",
    fill: "#080302"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(757,710)",
    d: "m0 0h29l23 4 21 7 14 7 5 5 4 8v9l-2 2h-7l-20-6-28-7-16-3-23-1-18 2-15 4-16 7-15 8-11 8-4 1 2-5 9-11 5-6 8-7 10-8 16-9 19-7z",
    fill: "#080302"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(751,810)",
    d: "m0 0 2 1-3 4-3 6 5 1v-2l2 1-2 5h2l1-6 5-4 7-2 1-2 17 4 6 2 1-2h2l1-2 8 9 3 8v17l-3 9-6 8-8 6-9 4-12 1-13-4-8-6-7-8-4-10v-15l4-11 9-10z",
    fill: "#25211E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1194,833)",
    d: "m0 0 2 1v4l3 3 2 6 2 20v13l-5 22-3 10-2 5-7 16-3 4-7 14-6 7-2-1 6-9-5 5-11 6h-2l2-11 5-36 2-39 6-12 4-2 4 4 4 11 2 16-1 18 4-11v-18l-3-14-7-14 1-5z",
    fill: "#815338"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(598,805)",
    d: "m0 0h5l7 21 1 7-4-2-9-7-5-2-4 1 6 5 1 4h-3v2h-2l-4 12v14l-1 4 1 4-1 4 2 14 2 10 2 5v4l2 1 3 11v3h2l12 24 6 8 7 5 9 3 3 9 3 16v4l-10-2-8-6-10-13-11-16-8-12-7-16-6-21-5-23-1-8v-32l4-16 5-10 7-6z",
    fill: "#A1714E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(796,1063)",
    d: "m0 0 9 1 36 6 36 3h31l31-2 38-5 10-2h5l-6 9-6 5-7 1-14 4-24 4-12 1h-58l-29-3-28-6-8-8-4-6z",
    fill: "#FEFEFD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1032,811)",
    d: "m0 0h6l9 6 7 11 3 12-1 10-4 10-9 10-12 6-4 1h-12l-9-3-9-6-6-7-4-8-1-4v-14l4-11 6-8 5-3-2 6-1 2 2 2v8l3 6 1 11 3 5 12 6 10-1 8-2v-22l-5-8 1-6 2 1v2h2l6 12-1 7h-2l1 7 1 4-3 1-1 4-3 6h7l1-2 5-4 3-12 2-1 1-6-4-1-3-6-5-7v-2l-4-2-5-4z",
    fill: "#231F1D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(841,426)",
    d: "m0 0h21l12 3 12 6 4 4v3l-9-1-13-3h-12l16 7 11 8v2l-17-4-9-1h-28l-13 2h-11v-2l15-9 2-1-4-1h-17l-25 5-9 2h-5l4-3 22-9 17-4z",
    fill: "#815338"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1007,1115)",
    d: "m0 0 2 3 2 4v14l2 25 1 2 2-3 1 4h2l1 2v13l2 1-6 3-7 6-16 9-8 4-1-40-3-1 6-5 11-18 7-20z",
    fill: "#805237"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(933,1018)",
    d: "m0 0h13l4 6 1-2 4 2 7 9 7 17-4 1h-9l-10-19-5-10-4-2 5 8 10 21-1 4-17 3h-22l-1-19v-13l-5-1 2-2z",
    fill: "#0A0605"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(937,1020)",
    d: "m0 0 5 2 14 28h15l11-2h5v-2l11-1 3-2h13l4 3-1 3-2-2h-11l-18 6-35 6-28 3h-55l-36-4-26-5-14-4-8-4h-8l-7 4h-2l1-5 6-4h7l19 5 18 4 9 1 1 1 12 1 9 2 10 1 22 1 1-12 3-14 3-1-1 14-2 13h34l23-2 9-2-1-5-11-23z",
    fill: "#9D6E4B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(981,1160)",
    d: "m0 0m-1 1v3l-1 5 3 17v8l-2 4h-2l-1-5-1-23-4 8v23l6-1-1 4h2v2l-11 6h-2v-9l-3-2v-2h-2l-1 8-2 4-3 1-2 3-1-1-2-13-2 4-2 10-1 4h-3v-9l-5-24-1-9 8-2 15-4z",
    fill: "#7D5036"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(718,1054)",
    d: "m0 0 3 3v36l1 3 1-30 2-4h3l1 2v14l-2 17 2 1-1 3-1 13 1 5-1 7 6-2-1 6-1 20-5-5-7-19-1-4-3-1-2-16-1-2v-11l-4 1 1 4-3 3 1 1 1 14 2 13-5-5-1-2-1-23 1-2h2l1-10 2-1 1-3h2l-1-11 1-4 2-2z",
    fill: "#0B0606"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1032,714)",
    d: "m0 0h10l15 5 21 11 13 10 11 11 8 11 1 5-6-3-16-10-15-8-17-6-22-3-16-1 1-3 6-3 3-1 2 1 16-2h3v-5l-4-2-3-4-11-2z",
    fill: "#090403"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(986,1072)",
    d: "m0 0v3l-6 7h-4l-1 3-13 4-22 4-23 2h-47l-16-1-16-2-22-5-6-4-6-6 1-2 3 3 28 6 29 3h58l26-3 22-5 5-2h5z",
    fill: "#9F704E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1031,1070)",
    d: "m0 0 2 1 8 16 1 4v13l3-1 1-8 2 1 4 14 4 19v19h-2v-2h-2l-2-6-2-1 1 16 1 2-4 2-3-2v-2h-3l-1 3h-1l-4-42-4-2-8-14-6-14v-3l4 1 7 11 3 6v3h2v-4h2l6 15 1 14h2v-16h2l1-4h-2l-1 3v-4l-3-1-4-9-3-11-2-4z",
    fill: "#0C0807"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(863,1172)",
    d: "m0 0m-4 1 4 1 1 4h-2l-4 21v19l-1 3h-7l-10-4-5-5h-7l1-9-4-1 3-5 1-9 1-2 4 1 4-1 1-2v-8l16-1z",
    fill: "#805237"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(775,820)",
    d: "m0 0 1 2 5 2 1 4 4 1 2 6 4 4 6 2v2l-2 2-4 1v10l-5 1v2l-5 2-7-1v2l-6 1v-2l-3 1-7-3-1-4h-2l-4-8-1-18h5l5 5h7l4-2 1-2h2z",
    fill: "#0A0403"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(944,968)",
    d: "m0 0 3 1 6 13 1 10-3 9-6 7-5 2h-5l-1-3h-9l-8 3-5 5-7 6-1 2-4 1h-12l-6-3-7-7-9-7h-10l-3 1h-10l-5-5-3-5-1-4v-7l3-11 4-7 3 1-3 8v16l3 6v2l10-2h11l10 5 12 11 7 2 5-2 10-9 9-6 3-1h13l8 2 4-6 1-3v-14l-3-8z",
    fill: "#090403"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1091,1232)",
    d: "m0 0 21 1 49 4 5 3 1 2v12l-8-1-7-3-7-1-26-1-21-4-7-9z",
    fill: "#B7262C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(761,1018)",
    d: "m0 0 3 1-8 11-5 11-9 23h-3l-2 10-1 16-3 22 1 1 3-4 5-34 4-10 2-1v14l-1 11-3 7-4 16-3 8h-2l-2 3-6 1v-8l-1-5 1-12 3-9 4-26 3-11 2-10 4-8 3-5h2l2-4 5-5z",
    fill: "#0A0605"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(694,1230)",
    d: "m0 0 3 1-9 12-1 1-24 2-25 2-12 3-5 2v-16l1-1 46-4z",
    fill: "#B8252C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1016,1073)",
    d: "m0 0 6 9v3l-6-2 10 23 6 9 3 3 4 39 1-2h3v2l3 1-5 6-11 9-3 3h-2l2-7v-19l4-1v-11l-1-9-3-12-5-8v-2h-2l-1 11 1 6h2l1 5v8l-4-4-6-15 2-18-3-3-2 10-2 8-1-4 4-22 2-5v-5z",
    fill: "#805237"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(774,1110)",
    d: "m0 0 2 1v9l-6 16v3l5-10 2-5 3 4 5 13-2 10-5 8-6 18-1 5-5-2-1-2-4-2h2l-1-11 4-19-2-1v-9l5-16 4-9z",
    fill: "#0C0807"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1013)",
    d: "m0 0h6l9 11 8 16 5 13 2 16-4-5-4-8-3-7-3-5-6-1-10 1-4 1-7-16-3-5v-4l9 3 5 3 7 11h1l1-2-1-4-8-14z",
    fill: "#0A0504"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(799,1158)",
    d: "m0 0 6 3v2l10 3 16 6 3 2h-5l-4 6-1 3-1 20 1 2-2 6-2 1-6-3 2-1-3-5-2 1-2-4v-10l2-3 2 1 3 10 3 2v-9l-2-10-5-9-2 5 1 2 1 6h-2v-2h-2l-1-15h-2l-2 5v29l-6-2v-16z",
    fill: "#805237"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(945,732)",
    d: "m0 0h8l1 4 3 3h6l3-2 13-1 6-2 14 2 2-3 10-1 4 2-3 1v2l-29 6-27 7-9 3h-8l-1-1v-12l3-6z",
    fill: "#1B1A1A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(932,1020)",
    d: "m0 0 4 1-1 6 3 10 3 11 1 7-8 1h-11l-4-11-4-20-2-2 7-1z",
    fill: "#815338"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(981,1160)",
    d: "m0 0m-1 1v3l-1 5 3 17v8l-2 4h-2l-1-5-1-23-4 8v23l6-1-1 4h2v2l-11 6h-2v-9l-3-2v-2h-2l-1 2-2-12-1-15h-5l4-2 18-8z",
    fill: "#815338"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(847,1021)",
    d: "m0 0h10l4 2-2 4-9 25-2 2-8-1-12-1v-2h2l1-5 8-14z",
    fill: "#815338"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(847,1019)",
    d: "m0 0 26 2 7 1 1 2-4 1h-11l-3 9-6 20h-9l10-27 3-4-4-1h-10l-9 12-8 16-3 1-5-1 1-6 8-15 8-9z",
    fill: "#0A0505"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1032,714)",
    d: "m0 0h10l15 5 12 6 1 3h-3l1 6 4 2 1 3-2 2-6-1-2-1v-2h-12v1l-32-2 1-3 6-3 3-1 2 1 16-2h3v-5l-4-2-3-4-11-2z",
    fill: "#1B1A1A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(976,437)",
    d: "m0 0 7 1 23 7 19 9 14 10 9 8-1 2-11-7-14-8-11-5 2 6 2 8h-4l-5-4v-2l-4-2-11-11-15-11z",
    fill: "#815338"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1140)",
    d: "m0 0 2 2 2 7 1 11v26l-4 3-12 5-2-1-1-22-2-13 2-4 2 4v2l6 2 3 24 1 1 1-43z",
    fill: "#0C0807"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(884,421)",
    d: "m0 0h8l15 3 27 9 11 6-2 1-13-4h-14l10 9-3 1-10-4-17-9-5-2-3-3-7-4 3-1z",
    fill: "#815338"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(749,484)",
    d: "m0 0h12l6 2v5l-4 3 7 8 2 3v4l-5-2-24-11-16-6 2-2z",
    fill: "#080302"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(978,462)",
    d: "m0 0 6 2 10 6 6 3 5 1 4 9 5 8 5 10 1 6-3 1v-2h-2l-10-18-5-4h-2l-1 4-4-1-8-11-4-6-3-5z",
    fill: "#080302"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1023,1019)",
    d: "m0 0 4 1 10 9 6 10 5 12 2 11v5h-3l-6-14-3-3v-2h-2-1l-1 3-5-8-6-15z",
    fill: "#0A0605"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(703,499)",
    d: "m0 0h10l16 5 3 3-31-2v2l11 3 3 3h-16l-30-1 5-4 14-7z",
    fill: "#815338"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(880,1027)",
    d: "m0 0 12 1 1 1 1 7v20l-1 1h-6l-2-1 1-13 2-14-2 1-4 20-1 6h-10l6-21z",
    fill: "#080403"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(895,1164)",
    d: "m0 0 6 2 3 7 2 20-1 17-3 14 5 1v1h-7l-8-2 3-2 2 1v-38z",
    fill: "#0B0706"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1127,547)",
    d: "m0 0h4l2 4 4 2 7 2 3 5h-9v4l9 3 12 7 6 6v2l-5-1-17-8-6-2-11-1-1-4 5-5 5-1-1-1-9-1-2-4z",
    fill: "#815338"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(746,1102)",
    d: "m0 0h2l1 13v14l1 4 2-1 2 6-1 4-6 6h-2l-1-2-2 5-2 1v3l-5-2v-24l1-5 1-3 2 5 1 8 2 1 1 9h2l-2-13v-13z",
    fill: "#2D2420"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(764,805)",
    d: "m0 0h13l11 2v2l6 4v3h-2l-1 3-6-2-11-3h-4v-2l-2 2v1l-8 2-4 3-2 6h-2l1-5-1 1-5-1-1 2 1-4 3-6 5-5z",
    fill: "#221610"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(761,1018)",
    d: "m0 0 3 1-8 11-5 11-9 23h-3l-2 7-2-3v-7l4-18 4-8 3-5h2l2-4 5-5z",
    fill: "#090504"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(981,1162)",
    d: "m0 0h3l1 2 1 35-2 5-5 1-2-1v-3l-5 1-1-1v-23l4-9 2 1 1 23v5h2l1-4v-8l-3-17 2-6z",
    fill: "#0B0706"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(788,1148)",
    d: "m0 0 6 5-1 5-3 37-5-2-1-6 1-19-3 9-3 11h-2l-1-4 1-5-2-1 7-15z",
    fill: "#805237"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(929,888)",
    d: "m0 0 3 1 4 40 2 12v8l-5-3-3-7-3-20-1-10v-10l2-10z",
    fill: "#080302"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1054,1074)",
    d: "m0 0h3l5 10 6 10 4 17 1 14-1 10-3 2-3-19-4-13-5-18-1-1z",
    fill: "#0A0504"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1016,1083)",
    d: "m0 0 4 1 7 11 3 6v3h2v-4h2l6 15v27h-3l-1-3-2-23-4-2-8-14-6-14z",
    fill: "#0B0706"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1057,486)",
    d: "m0 0 4 5 14 14 2 4-1 10-3 10h-3l-9-29-4-3h3l-3-8z",
    fill: "#080302"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(762,815)",
    d: "m0 0 8 1 4 5 1 5-3 7-4 2h-7l-5-4-2-8 3-5z",
    fill: "#FEFEFD"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(811,1015)",
    d: "m0 0 5 1-2 6-6 10-6 11-1 1h-5l1-7 1-4h-2l-2 7-2-4 7-13 8-7z",
    fill: "#0C0707"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1010,817)",
    d: "m0 0h8l6 5v9l-4 4h-12l-4-6 1-7z",
    fill: "#FEFEFD"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(987,1020)",
    d: "m0 0 9 3 5 3 7 11h1l1-2 3 1 1 5-3 2-10 1-4 1-7-16-3-5z",
    fill: "#0F0A08"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(843,458)",
    d: "m0 0h18l10 3 12 7 9 9v2l-5-1-21-10-20-7z",
    fill: "#815338"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(925,1024)",
    d: "m0 0h3l2 10 3 8 4 12-1 1h-11l-4-18v-11z",
    fill: "#080302"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(788,1011)",
    d: "m0 0 4 1-2 5-10 13-7 9h-2l-1 2-1-1 1-8 3-4h-2l-1-6 9-7 5-3z",
    fill: "#0A0505"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(634,573)",
    d: "m0 0 5 1-4 7-13 14-10 15-4 5-1-2 5-14 7-12 11-11z",
    fill: "#815338"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(846,1176)",
    d: "m0 0 7 1 1 2-3 1-1 3-3 28-3 1-3-3-1-4v-14l3-14z",
    fill: "#0B0706"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(839,1020)",
    d: "m0 0h8l-2 5-7 9-8 16-3 1-5-1 1-6 8-15z",
    fill: "#0A0504"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(778,1129)",
    d: "m0 0h1l1 11-4 10 1 4 5-11h2l-1 8-5 8-6 18-1 5-3-1 1-16 7-33z",
    fill: "#815338"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1105,1069)",
    d: "m0 0 2 2v4l4-1-2 7-4 9-3 5-6-3v-3l-2-2-1-14h2v-2l4-1 5 5z",
    fill: "#1C1B1B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(870,1165)",
    d: "m0 0h10v7l-3 24-3 3-3-3-1-6z",
    fill: "#090504"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(955,1016)",
    d: "m0 0 7 1 8 9 11 22-9 1-2-5-8-16-7-10z",
    fill: "#0A0605"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(747,1064)",
    d: "m0 0h1v14l-1 11-3 7-4 16-3 8h-2l-2 3-4 1 1-5 1-3h2l2-5 2-2 5-34 4-10z",
    fill: "#0D0908"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(829,1173)",
    d: "m0 0 10 3 1 1v7l-2 3-5 1-3-2-1 11-1 3h-5v-17l4-8z",
    fill: "#090403"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1032,811)",
    d: "m0 0h6l9 6 7 11 3 12-1 10h-1l-1-11-4-1-3-6-5-7v-2l-4-2-5-4z",
    fill: "#2E2521"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(898,1027)",
    d: "m0 0h6l4 16 1 13-2 1h-7l-3-24v-5z",
    fill: "#090403"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(969,1015)",
    d: "m0 0 5 1 12 14 4 9 3 5v2l-7 1-2-1-8-16-7-12z",
    fill: "#0B0706"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(749,466)",
    d: "m0 0h22l12 3-1 2-25 1-23 3h-5l4-4 11-4z",
    fill: "#835439"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(851,1025)",
    d: "m0 0h4l-1 5-8 16-3 7-9-1 2-6 9-16z",
    fill: "#090403"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1121,999)",
    d: "m0 0 4 2 3 7v4h-2v15l-1 5-2-4-2 2-3-4v-7h-2l-5-11 2-4 6 9 2 4 2 1 1-5-4-1-1-1v-10z",
    fill: "#161414"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(760,781)",
    d: "m0 0h17l15 2 13 5 14 8-2 2-4-2v-2l-5-1-9-4-14-3-20-1-17 1-12 2 3-3 12-3z",
    fill: "#815338"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(701,1045)",
    d: "m0 0h2l1 2v12l-1 10 2 3h-3l-1 9h2l-3 16-3 1-1-3v-21l3-6v-15z",
    fill: "#1C1B1B"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(976,1077)",
    d: "m0 0 4 1-2 2-19 5-20 4-23 2h-43l-6-1v-1l53-1 3-1 26-3 22-5z",
    fill: "#86583C"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(828,1021)",
    d: "m0 0h2l-1 5-9 16-3 6-9-1v-3l2-5h2l2-4 7-9 5-4z",
    fill: "#0A0605"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1087,1040)",
    d: "m0 0 5 2 7 8-1 2-2 2 4 2 6 9 2 2v2h-3v7l-4-2-3-6-4-10v-3l-3-3-5-7z",
    fill: "#0B0706"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1081,1047)",
    d: "m0 0 5 5 7 12 1 18-3 3-4-14-8-15-1-5z",
    fill: "#090403"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(913,1024)",
    d: "m0 0 3 1 4 20 3 11h-11l-1-19v-12z",
    fill: "#090504"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(762,1028)",
    d: "m0 0h3l-1 9-5 17-4 8-3 1-2-1 1-9 5-14z",
    fill: "#0A0504"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(713,1075)",
    d: "m0 0 2 1v20h-2l-1-6-4 1 1 4-3 3 1 1 1 14 2 13-5-5-1-2-1-23 1-2h2l1-10 2-1 1-3 2-1z",
    fill: "#2D2520"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(715,1106)",
    d: "m0 0h2l4 14 4 9 2 1-2-5 3 1 3-4h2l-1 6-1 20-5-5-7-19-1-4-3-1-1-8z",
    fill: "#7E5137"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(888,1028)",
    d: "m0 0 5 1 1 7v20l-1 1h-6l-2-1 1-13z",
    fill: "#0A0505"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(811,1171)",
    d: "m0 0 4 4 4 9 1 7v11l-2-1v-2l-3-1-3-10-1 1-3 4-1-8v-11h1l1 7-1 2h2v-4-4z",
    fill: "#0B0706"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(769,1083)",
    d: "m0 0h3l2 8-1 11-5 11-2 6h-2l1-7-1-9 4-19z",
    fill: "#080302"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1043,1123)",
    d: "m0 0 2 1-1 2 2 1h-2l2 6v4h-2l1 14 5 5-4 3-3-2v-2h-3l-1 3h-1l-1-16h2v-16l2 1v2h2z",
    fill: "#1D1B1B"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(688,516)",
    d: "m0 0h19l3 2-21 3-32 2v-2l6-3 7-1z",
    fill: "#815338"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(766,1069)",
    d: "m0 0 2 2h-2l-1 5-3 6-4 16-2 4-2 7-2-1 1-17 3-12 3-6h4z",
    fill: "#0D0909"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1032,470)",
    d: "m0 0 5 2 8 5 6 7 2 9v9l-3-1-3-7-9-15z",
    fill: "#815338"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(668,1342)",
    d: "m0 0 8 1 6 2h8v4l1-5 7-1 3 3-3 5-5 4-4-1-21-10z",
    fill: "#A4724F"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(871,1027)",
    d: "m0 0 3 1-4 16-2 12-8-1 2-10 6-16z",
    fill: "#0A0605"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(911,454)",
    d: "m0 0 8 4 7 5 9 12 2 8v4l-3-1-7-11-11-14-5-5z",
    fill: "#815338"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(872 1e3)",
    d: "m0 0 6 2 2 2 21 3h5l-4 5-6 4-7-1-11-9-6-5z",
    fill: "#815338"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(841,1307)",
    d: "m0 0 8 1 17 3 14 1h30l19-2 8-2 4 1-16 4-17 2h-33l-24-4-10-3z",
    fill: "#926343"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1092,1289)",
    d: "m0 0 7 1 4 5-1 6-3 1h-9l-3-2v-8z",
    fill: "#815338"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(975,1169)",
    d: "m0 0 2 1 1 23-2 7-4 2-1-1v-23z",
    fill: "#0B0706"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1036,1055)",
    d: "m0 0 2 1 3 9 4 8 2 11-3 1-8-11-2-5-1-8 3-1z",
    fill: "#0B0605"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(774,1110)",
    d: "m0 0 2 1v9l-6 16-4 9h-2v-9l5-16 4-9z",
    fill: "#0A0504"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(684,1021)",
    d: "m0 0 6 4v7l-4 21-1 2h-2l-1-10v-13z",
    fill: "#0D0908"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1056,457)",
    d: "m0 0 5 2 15 15 7 14 1 5-4-1-8-14-13-16z",
    fill: "#815338"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1031,1070)",
    d: "m0 0 2 1 8 16 1 4v10l-1 3h-2l-3-6-3-11-2-4z",
    fill: "#0B0606"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(759,1118)",
    d: "m0 0 3 1v10l-2 21-4 2-2-12 2-13z",
    fill: "#0B0706"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(725,1062)",
    d: "m0 0h3l1 2v14l-3 19-2 1-1-14v-18z",
    fill: "#0A0504"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(746,1102)",
    d: "m0 0h2l1 13v13l-1 5 1 8h-2l-3-4-1-6v-13z",
    fill: "#0E0A09"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 783)",
    d: "m0 0h32l4 2-4 1-27 1-18 2-1-3 7-2z",
    fill: "#815338"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(884,1165)",
    d: "m0 0h6l1 1v21l-3 1-4-2z",
    fill: "#080403"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1183,810)",
    d: "m0 0h13v1l-11 2-4 5v9l-4 6v5l2-3h2l2-4 6-4 4-1-12 12-8 6 1-10 5-19z",
    fill: "#815338"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(687,1289)",
    d: "m0 0 9 1 2 2-1 7-5 2-8-1-2-2 1-5z",
    fill: "#956645"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(748,1252)",
    d: "m0 0 2 3 3 5 5 17 1 14-4 3-2-1-1-5 1-2-2-1 4-1-4-17-2-6z",
    fill: "#A66749"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(952,1174)",
    d: "m0 0h5l1 2v22l-4-1-2-1-1-20z",
    fill: "#090403"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1015,1160)",
    d: "m0 0 2 4h2l1 2v13l2 1-6 3-4 3-1-3 2-5-1-7 1-7z",
    fill: "#1C1A1A"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1033,820)",
    d: "m0 0 2 1v2h2l6 12-1 7h-2l1 7 1 4-3 1-1 3-1-4v-19l-5-8z",
    fill: "#1C1B1B"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1075,1072)",
    d: "m0 0 4 2 4 9 1 9 3 6v2h-2l-5-8-3-1-4-10 2-6z",
    fill: "#7C5036"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(958,1189)",
    d: "m0 0h1l2 15-3 7-3 1-2 3-1-1-1-16 1-2 5 1z",
    fill: "#151212"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(723,1084)",
    d: "m0 0h1l1 13 1-6 1 4 2 1-1 3-1 13 1 5-1 7h2l-1 3-1-2h-2l-2-11-1-12-1-3 1-3z",
    fill: "#352922"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(937,1020)",
    d: "m0 0 5 2 14 28 7 1v1l-12 1-1-6-11-23z",
    fill: "#815338"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1019,1063)",
    d: "m0 0 4 1 2 5 1 9-2 6-5-5-2-3 1-11z",
    fill: "#0E0A09"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(957,1023)",
    d: "m0 0 4 2 8 14 4 9 4 2-12 1 3-2-7-16-3-4z",
    fill: "#84563A"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(996,1338)",
    d: "m0 0 1 3-14 38-6 13 3 2h-6l2-6 14-36z",
    fill: "#916243"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(831,1174)",
    d: "m0 0 6 1 3 2v7l-2 3-5 1-3-2-1 2z",
    fill: "#0A0504"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(886,1029)",
    d: "m0 0h2l-1 14-2 13 2 1h-15v-1h9l1-12 3-14z",
    fill: "#88593D"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,512)",
    d: "m0 0h16l13 2-4 2-20 1h-15v-1l7-2h5z",
    fill: "#0C0807"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(668,1008)",
    d: "m0 0 3 1 1 2v6h2l2 7 1 2h-3v2l5 1-1 3-4 2-6-17z",
    fill: "#100C0C"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1022,1083)",
    d: "m0 0 4 1 6 10 1 6-1 4h-2l-6-12-4-7h2z",
    fill: "#1F1B1A"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1069,1099)",
    d: "m0 0h2l2 4 2 2 1 10v9l-3 9-2 1 1-9-1-14z",
    fill: "#815338"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1209,901)",
    d: "m0 0h1l-1 9-5 16-5 12-7 12-1-3 3-4 5-13 6-15 3-12z",
    fill: "#815338"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(704,1095)",
    d: "m0 0 3 4 1 14 2 13-5-5-1-2-1-23z",
    fill: "#815338"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1121,999)",
    d: "m0 0 4 2 3 7v4h-2v5l-3-4-4-2v-10z",
    fill: "#0A0605"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(847,1019)",
    d: "m0 0 26 2 7 1 1 2-4 1h-11l-1 2v-2h-4v-2l-4-1h-9z",
    fill: "#0F0B0B"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(776,1112)",
    d: "m0 0 2 4 3 11-1 4-3-5-5 12-4 4 2-9 5-13z",
    fill: "#815338"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1153,969)",
    d: "m0 0 1 4 3 1-1 2-1 8v3h-3v2l6-1 2 2-4 2h-6l-1-4z",
    fill: "#815338"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1116,1043)",
    d: "m0 0h2l2 4-2 5-2 6-1 5h-2l-1-3-4-2 1-2 2 1 3-9z",
    fill: "#181716"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1087,1040)",
    d: "m0 0 5 2 7 8-1 2-6 1-6-8z",
    fill: "#080302"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(779,1131)",
    d: "m0 0h2l4 10v2h-3l-3 9-2 3-2-2 2-9 2-4z",
    fill: "#0C0807"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(748,1129)",
    d: "m0 0 2 4 2-1 2 6-1 4-6 6h-2l-1-4v-6l3 1v2h2l-2-10z",
    fill: "#1D1C1C"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(738,1104)",
    d: "m0 0h3l-2 12-3 4-3 3-4 1 1-5 1-3h2l2-5 2-2z",
    fill: "#1C1B1B"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1098,1073)",
    d: "m0 0 3 1v5h3l1-2 1 4-2 2-1 4-2 3-2-1v-5l-2-4-1-3z",
    fill: "#080302"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(701,1045)",
    d: "m0 0h2l1 2v12l-1 5h-3l-1-2v-9z",
    fill: "#0C0807"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(803,829)",
    d: "m0 0 2 3 1 5v11l-2 1v-5l-3 1-1-4 1-10z",
    fill: "#120A08"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1015,1160)",
    d: "m0 0 2 4h2l1 2v10l-1 2h-3l-1-5z",
    fill: "#815338"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(715,1060)",
    d: "m0 0h1v33h-1l-1-17-2 3-1-10 1-4 2-2z",
    fill: "#1D1C1C"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1083,1112)",
    d: "m0 0h1l1 9-10 11-1-3 1-5 3-1 1-9 2 4z",
    fill: "#1D1C1C"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(802,438)",
    d: "m0 0h18l3 2-5 3-9-1-8-2z",
    fill: "#1D1C1C"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(689,1289)",
    d: "m0 0 7 1 2 2v5l-4 2h-7l1-2 2 1 1-6z",
    fill: "#BC9A82"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1043)",
    d: "m0 0h13l4 3-1 3-2-2h-11l-6 1 1-4z",
    fill: "#815338"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(744,845)",
    d: "m0 0 4 3 3 1 1 7 2 1-1 3-4-3v-2h-3l-4-7z",
    fill: "#080302"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(870,1213)",
    d: "m0 0 2 3-1 9h-6l-1-2v-7l5-1z",
    fill: "#1D1C1C"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(952,1202)",
    d: "m0 0 4 2 1-2h2v7l-1 2-3 1-2 3-1-1z",
    fill: "#815338"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1070,1093)",
    d: "m0 0 2 1 2 6 3 3 1 7-1 12h-1l-2-17-3-3z",
    fill: "#191818"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(976,1077)",
    d: "m0 0 4 1-2 2-19 5-8 1-2-2 22-5z",
    fill: "#916243"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1046,1095)",
    d: "m0 0 2 1 1 6-1 4v6l-2 1v-4h-2l-1 3v-4l-3-1 1-5 1 2 3-1z",
    fill: "#1E1C1C"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1112 1e3)",
    d: "m0 0 3 3 6 10-1 2h-4l-5-11z",
    fill: "#0C0807"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(916,1173)",
    d: "m0 0 5 1 6 4-2 6-3-1-5-5z",
    fill: "#100C0C"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(928,1028)",
    d: "m0 0h1l2 7 3 10 3 9h-3l-6-18-1-5z",
    fill: "#1D1C1C"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(787,1029)",
    d: "m0 0 2 1-3 10-7-1 4-6z",
    fill: "#0F0C0B"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(724,1302)",
    d: "m0 0h9v2l-23 3v-3z",
    fill: "#9F6245"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1044,1300)",
    d: "m0 0 10 1 16 3 2 2h-7l-20-4z",
    fill: "#A47450"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(807,1174)",
    d: "m0 0h1l1 7-1 2h2v-4l2-2 2 10h-3l-2 6-2-4z",
    fill: "#1D1C1C"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(883,1043)",
    d: "m0 0h1l1 13 2 1h-15v-1h9l1-12z",
    fill: "#8A5C3E"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(672,1017)",
    d: "m0 0h2l2 7 1 2h-3v2l5 1-1 3-4 2-2-8z",
    fill: "#1A1919"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(664,994)",
    d: "m0 0 3 3v8h-3l-1 3-2-4z",
    fill: "#120F0E"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(713,1075)",
    d: "m0 0 2 1v20h-2l-1-17z",
    fill: "#815338"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(766,1271)",
    d: "m0 0 2 3 5 16-1 4-3-7-2-4-2-7v-3z",
    fill: "#614533"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1022,1087)",
    d: "m0 0 4 1 5 10v5l-4-5-5-9z",
    fill: "#815338"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1087,1071)",
    d: "m0 0 2 3 3 9 2-1-2 9-2-3-4-13z",
    fill: "#1C1B1B"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(983,1370)",
    d: "m0 0 1 3-2 7-5 12 3 2h-6l2-6z",
    fill: "#976747"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1009,813)",
    d: "m0 0 5 1h5l3 2-1 3-3-1h-8l-3 2-1-3h3l-1-3z",
    fill: "#3E3027"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1072,1118)",
    d: "m0 0h1v11l-2 7-2 1-1-12 3-1z",
    fill: "#1A1818"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(698,1084)",
    d: "m0 0 2 2 2-2-1 7-1 6-3 1v-11z",
    fill: "#7E5137"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1089,1290)",
    d: "m0 0h3v8h3l1 3-7-1-1-4z",
    fill: "#A47450"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(951,747)",
    d: "m0 0 4 2-2 2-6 2h-8l-1-3 5 1z",
    fill: "#0A0505"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1115,555)",
    d: "m0 0v3l-6 10-4 3-1-2 2-5 3 1v-2h2v-5z",
    fill: "#1D1C1C"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1045,473)",
    d: "m0 0h2l5 5v3h2l2 5-5-3-3-2-3-5z",
    fill: "#080302"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1114,1052)",
    d: "m0 0 3 1-2 10h-2l-1-3-4-2 1-2 2 1 1-2z",
    fill: "#1B1A1A"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1032,1285)",
    d: "m0 0h2l1 9-5-1-3-3h2l1-4z",
    fill: "#A47450"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1023,463)",
    d: "m0 0 7 2 1 3-1 3h-4l-3-6z",
    fill: "#080302"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(598,823)",
    d: "m0 0 4 1 5 4 1-5 2 3 1 7-4-2-9-7z",
    fill: "#815338"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1095,1291)",
    d: "m0 0 6 1v7l-4 1z",
    fill: "#A47450"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(726,1330)",
    d: "m0 0 2 1-3 4h-2l-1 5-6 7-1-2 4-5 3-6z",
    fill: "#A36045"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(688,1290)",
    d: "m0 0 4 2-1 4-1 2-5-1 2-6z",
    fill: "#815238"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(977,1196)",
    d: "m0 0 3 3v3l5-2-1 4-5 1-2-1v-3l-3 1v-2h2z",
    fill: "#1D1C1C"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1176,968)",
    d: "m0 0 2 1-9 12h-3l2-4h2l2-5 3-1z",
    fill: "#815338"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(680,514)",
    d: "m0 0h9l2 2-3 1h-15v-1z",
    fill: "#1B1A1A"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(847,1019)",
    d: "m0 0 17 1-2 2 3 1v2h-4v-2l-4-1h-9z",
    fill: "#1D1C1C"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1032,811)",
    d: "m0 0h6l2 1-2 5-4 1z",
    fill: "#1C1816"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(982,1193)",
    d: "m0 0 1 3h2l1 3-3 3h-3l-1-4z",
    fill: "#0E0B0A"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(724,1113)",
    d: "m0 0 3 1 1 3-1 7h2l-1 3-1-2h-2l-2-11z",
    fill: "#1D1C1C"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(713,1122)",
    d: "m0 0 2 2 3 9 1 4-5-5-2-4z",
    fill: "#654430"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(675,1048)",
    d: "m0 0h1v6l1 2h-2v5l-2-1-2-11z",
    fill: "#1D1C1C"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(958,1189)",
    d: "m0 0h1l2 15-2 3v-5h-2l-1-4 1-2z",
    fill: "#1D1C1C"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1087,1100)",
    d: "m0 0 2 1v2h3l2 5-3 3-2-1-1-5z",
    fill: "#4B3529"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1076,1089)",
    d: "m0 0 1 2 4 1 2 4h-3l-3 2-1-1z",
    fill: "#1D1C1C"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(801,440)",
    d: "m0 0h6l9 2-1 3-3 1-7-4z",
    fill: "#090504"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(713,1096)",
    d: "m0 0h2l1 7 2 2-1 3v-2h-2v5h-1l-1-8-1-2z",
    fill: "#1D1C1C"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1124)",
    d: "m0 0 1 4-3 9-3 2 1-5z",
    fill: "#0A0504"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1128,1009)",
    d: "m0 0h1l-1 11-2 4h-1l1-12h2z",
    fill: "#52392A"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(786,1366)",
    d: "m0 0 2 3 2 5v5l-4-2 1-4-2-1z",
    fill: "#A47450"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(697,1293)",
    d: "m0 0 1 4-4 2h-7l1-2 2 1 1-3 5 1z",
    fill: "#BB987E"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(937,1020)",
    d: "m0 0 5 2 3 6v2h-2v-2h-2l-4-6z",
    fill: "#8D5E40"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(831,1174)",
    d: "m0 0 3 1h-2l1 12-3-1-1 2z",
    fill: "#201D1D"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(765,1105)",
    d: "m0 0 2 4 1 4-2 6h-2l1-7-1-4z",
    fill: "#1D1C1C"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1039,470)",
    d: "m0 0 5 1 2 2 1 4v3l-5-6-3-3z",
    fill: "#120F0F"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(839,1176)",
    d: "m0 0h7l-3 1-1 7h-2z",
    fill: "#815338"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(777,1124)",
    d: "m0 0 3 4-1 3-1-1-2 7-2-4z",
    fill: "#131010"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1048,1056)",
    d: "m0 0h1l1 11h-3l-2-6 3 1z",
    fill: "#1D1C1C"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,1056)",
    d: "m0 0h1v9l3 1-3 3-3-3z",
    fill: "#201E1D"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1011,1043)",
    d: "m0 0 5 1 2 2-1 3-4-3-10-1v-1z",
    fill: "#A47450"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1118,1011)",
    d: "m0 0 7 2-2 5-4-2z",
    fill: "#4B3528"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.df2208c9cd802cac7db6f386770617fa.svg";
export { ForwardRef as ReactComponent };